import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { useTrackMachinePerformanceOpened } from '@v2/pages/machines/navigation/hooks/useTrackMachinePerformanceOpened';
import { BOTTOM_SHEET_NAVIGATION_CONFIG, BOTTOM_SHEET_SCREEN_CONFIG } from '@v2/pages/common/constants/base.constants';
import { performanceConfig, PERFORMANCE_MAIN_SCREEN } from '.';
import NavigatorBottomSheetWrapper from '@components/common/NavigatorBottomSheetWrapper';

const PerformanceStack = createStackNavigator();

const PerformanceWebNavigation = () => {
  useTrackMachinePerformanceOpened();

  return (
    <NavigatorBottomSheetWrapper screenNameToRemove={PERFORMANCE_MAIN_SCREEN} bottomSheetId={PERFORMANCE_MAIN_SCREEN}>
      <PerformanceStack.Navigator screenOptions={BOTTOM_SHEET_NAVIGATION_CONFIG}>
        {performanceConfig.map(({ Component, name }) => (
          <PerformanceStack.Screen key={name} name={name} component={Component} options={BOTTOM_SHEET_SCREEN_CONFIG} />
        ))}
      </PerformanceStack.Navigator>
    </NavigatorBottomSheetWrapper>
  );
};

export { PerformanceWebNavigation };
